import { InjectionToken } from '@angular/core';

export const PORTAL_BASE_URL = new InjectionToken<string>('PORTAL_BASE_URL');
